import type { RumInitConfiguration } from '@datadog/browser-rum';
import { datadogRum } from '@datadog/browser-rum';

import type { DatadogOptions, DatadogRumClientInstance } from '../declarations';

export const defaultInitDatadogRumClient = (
  datadogInitOpts: DatadogOptions,
): DatadogRumClientInstance => {
  datadogRum.init({ ...datadogInitOpts } as RumInitConfiguration);
  datadogRum.startSessionReplayRecording();
  return datadogRum as unknown as DatadogRumClientInstance;
};
